/**
 * CardBiz field 30 (Masked PAN) is often like "42833322072936162" or "4687860000004815".
 * MenuX "Card Ref." is typically the last 4 digits of the card.
 */
export function cardReferenceForMenuX(
	maskedCardNo?: string | null,
): string {
	if (!maskedCardNo) return '';

	const trimmed = String(maskedCardNo).trim();
	if (!trimmed) return '';

	const digits = trimmed.replace(/\D/g, '');
	if (digits.length >= 4) {
		return digits.slice(-4);
	}

	return trimmed;
}
